export default Object.freeze({
  WINDOW: 'window_queue',
  OFFICE: 'office_queue',
});
